import { ActionType } from '../../constants/ActionTypes'

export default function languagesReducer(state = {}, action) {
    switch (action.type) {
        case ActionType.GET_LANGUAGES_BEGIN:
            return {
                ...state,
            }
        case ActionType.GET_LANGUAGES_SUCCESS:
            return {
                ...state,
                data: action.payload.Data
            }
        case ActionType.GET_LANGUAGES_FAILURE:
            return {
                ...state,
                data: action.payload.Data
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/settings/LanguagesReducer.js